export default __webpack_public_path__ + "static/media/mainStaffDashboard.03cd84ba.svg";